// Configuration file for the Stock Trading Simulator

export const ALPHA_VANTAGE_API_KEY = "mZaCU1705VC1XqCORwoiBylcekWVixHn";
